import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridComponent } from '@progress/kendo-angular-grid';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-pos-tfg-campaign-details-lines-breakdown',
  templateUrl: './pos-tfg-campaign-details-lines-breakdown.component.html',
  styleUrls: ['./pos-tfg-campaign-details-lines-breakdown.component.scss']
})
export class PosTfgCampaignDetailsLinesBreakdownComponent implements OnInit, AfterViewInit {
  gridData: any[];
  filename: string;
  constructor(
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.filename = `tfg_sales_order_campaign_line_details_${this.data}.xlsx`;
    }

  ngAfterViewInit(): void {
    this.baseService.executeCommand<any[]>('portal_tfg_sales_order_campaign_line_details', {salesOrderHeaderId: this.data})
    .subscribe(response => {
      if (response.responseCode === 0) {
        this.gridData = response.data;

      } else {
        this.gridData = [];
      }
    });
  }

  ngOnInit(): void {

  }

}
